import {
  useMutation,
  useQueryClient,
  type QueryClient,
} from '@tanstack/react-query';

export interface DeploymentMutationOptions<TResult> {
  onSuccess?: (result: TResult) => void;
  onError?: (error: Error) => void;
}

interface UseDeploymentMutationConfig<TArgs, TResult>
  extends DeploymentMutationOptions<TResult> {
  mutationFn: (args: TArgs) => Promise<TResult>;
  invalidate?: (queryClient: QueryClient, args: TArgs) => void;
  errorLabel: string;
}

export const useDeploymentMutation = <TArgs, TResult>(
  config: UseDeploymentMutationConfig<TArgs, TResult>
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: config.mutationFn,
    onSuccess: (result, args) => {
      config.invalidate?.(queryClient, args);
      config.onSuccess?.(result);
    },
    onError: (error: Error) => {
      console.error(`${config.errorLabel}:`, error);
      config.onError?.(error);
    },
  });
};
